module.exports = __webpack_public_path__ + "img/SJM.d7b21049.svg";